import { render, staticRenderFns } from "./ExtraProcessPDF.vue?vue&type=template&id=87b17632&scoped=true&"
import script from "./ExtraProcessPDF.vue?vue&type=script&lang=js&"
export * from "./ExtraProcessPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b17632",
  null
  
)

export default component.exports